import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

import CopySalary from '../salary/CopySalary'
export default function GensalaryPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="GensalaryPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('gensalary')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div><CopySalary/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
